import {
  base,
  binding,
  boh,
  fingers,
  laces,
  layer3d,
  palm,
  placeholder,
  stitching,
  web,
  welting,
} from './assets'

const assets: any = [
  { src: boh, x: 0, y: 0, itemId: 101 },
  { src: base, x: 0, y: 0, itemId: 102 },
  { src: fingers, x: 0, y: 0, itemId: 106 },
  { src: palm, x: 0, y: 0, itemId: 103 },
  { src: welting, x: 0, y: 0, itemId: 109 },
  { src: binding, x: 0, y: 0, itemId: 108 },
  {
    src: stitching,
    x: 0,
    y: 0,
    itemId: 114,
    blendMode: 'no-blend',
  },
  { src: laces, x: 0, y: 0, itemId: 107 },
  { src: placeholder, x: 0, y: 0, itemId: 114 },
]

const webs = {
  h: [{ src: web, x: 0, y: 0, itemId: 105 }],
  i: [{ src: web, x: 0, y: 0, itemId: 105 }],
  p: [{ src: web, x: 0, y: 0, itemId: 105 }],
  'mod-bar': [{ src: web, x: 0, y: 0, itemId: 105 }],
  'single-post': [{ src: web, x: 0, y: 0, itemId: 105 }],
  'snake-eyes': [{ src: web, x: 0, y: 0, itemId: 105 }],
  trap: [{ src: web, x: 0, y: 0, itemId: 105 }],
}

const data = {
  assets,
  '3dLayer': [{ src: layer3d, x: 0, y: 0, globalComposition: 'normal' }],
  ...webs,
}

export default data
